var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function hasEndRole(client, alias, role, eid) {
    return __awaiter(this, void 0, void 0, function () {
        var list, _i, list_1, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getEndRoles(client, alias, role)];
                case 1:
                    list = _a.sent();
                    for (_i = 0, list_1 = list; _i < list_1.length; _i++) {
                        i = list_1[_i];
                        if (i.role === role && i.eid === eid) {
                            return [2 /*return*/, true];
                        }
                    }
                    return [2 /*return*/, false];
            }
        });
    });
}
export function getEndRoles(client, alias, role) {
    return __awaiter(this, void 0, void 0, function () {
        var path, response, _a, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    path = role !== undefined
                        ? "/identifiers/".concat(alias, "/endroles/").concat(role)
                        : "/identifiers/".concat(alias, "/endroles");
                    return [4 /*yield*/, client.fetch(path, 'GET', null)];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    _a = Error.bind;
                    return [4 /*yield*/, response.text()];
                case 2: throw new (_a.apply(Error, [void 0, _b.sent()]))();
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    result = _b.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
export function resolveOobi(client, oobi, alias) {
    return __awaiter(this, void 0, void 0, function () {
        var op;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, client.oobis().resolve(oobi, alias)];
                case 1:
                    op = _c.sent();
                    // KERIA may return done:true immediately for an already-resolved OOBI.
                    // If it also sets op.error, we don't want to throw here — just log and continue.
                    if (op.done) {
                        if (op.error) {
                            console.warn('[resolveOobi] OOBI already resolved or error, ignoring:', oobi, op.error);
                        }
                        return [2 /*return*/, (_b = (_a = op.response) === null || _a === void 0 ? void 0 : _a.i) !== null && _b !== void 0 ? _b : ''];
                    }
                    return [4 /*yield*/, waitOperation(client, op)];
                case 2:
                    op = _c.sent();
                    return [2 /*return*/, op.response.i];
            }
        });
    });
}
export function waitOperation(client, op, signal) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof op === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, client.operations().get(op)];
                case 1:
                    op = _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, client
                        .operations()
                        .wait(op, { signal: signal !== null && signal !== void 0 ? signal : AbortSignal.timeout(30000) })];
                case 3:
                    op = _a.sent();
                    return [4 /*yield*/, deleteOperations(client, op)];
                case 4:
                    _a.sent();
                    if (op.error) {
                        throw new Error("Operation ".concat(op.name, " failed: ").concat(JSON.stringify(op.error)));
                    }
                    return [2 /*return*/, op];
            }
        });
    });
}
export function deleteOperations(client, op) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = op.metadata) === null || _a === void 0 ? void 0 : _a.depends)) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteOperations(client, op.metadata.depends)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [4 /*yield*/, client.operations().delete(op.name)];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function markAndRemoveNotification(client, noteId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 4]);
                    return [4 /*yield*/, client.notifications().mark(noteId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, client.notifications().delete(noteId)];
                case 3:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getStates(client, prefixes) {
    return __awaiter(this, void 0, void 0, function () {
        var participantStates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(prefixes.map(function (p) { return client.keyStates().get(p); }))];
                case 1:
                    participantStates = _a.sent();
                    return [2 /*return*/, participantStates.map(function (s) { return s[0]; })];
            }
        });
    });
}
export function createTimestamp() {
    return new Date().toISOString().replace('Z', '000+00:00');
}
export function removeNullOrUndefined(obj) {
    Object.keys(obj).forEach(function (key) {
        if (obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
    });
}
